export default "__VITE_ASSET__BpoJG66h__"